module.exports = __webpack_public_path__ + "img/capa2.a8230727.webp";